import { Container } from '@pixi/react';
import { isMobile } from '../../../helpers';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { ScaleComponentProps } from '../index.types';

export const ScaleComponent: React.FC<Partial<ScaleComponentProps>> = observer(
  ({
    isTop,
    children,
    isBottom,
    name = '',
    margin = 0,
    positionX = 0,
    positionY = 0,
    isCenterVertical,
    isCenterHorizontal,
    childrenDefaultWidth = 0,
  }) => {
    const ref = useRef<any>();

    useEffect(() => {
      if (!isMobile()) return;

      const applyLayout = () => {
        if (!ref.current) return;
        const scale = Math.min(window.innerWidth / 540, window.innerHeight / 960);
        ref.current.scale.set(scale);
        const childrenWidth = childrenDefaultWidth ? childrenDefaultWidth * scale : ref.current.width;
        ref.current.x = positionX;
        ref.current.y = positionY;
        if (isBottom) {
          ref.current.y = window.innerHeight - ref.current.height / 2 - margin;
        }
        if (isTop) {
          ref.current.y = ref.current.height / 2 + margin;
        }
        if (isCenterVertical) {
          ref.current.y = window.innerHeight / 2 - ref.current.height;
        }
        if (isCenterHorizontal) {
          const scaleX = (window.innerWidth - childrenWidth) / 2;
          ref.current.x = scaleX < 0 ? 0 : scaleX;
        }
      };

      applyLayout();
      window.addEventListener('resize', applyLayout);
      window.addEventListener('orientationchange', applyLayout);

      return () => {
        window.removeEventListener('resize', applyLayout);
        window.removeEventListener('orientationchange', applyLayout);
      };
    }, [
      margin,
      isTop,
      positionX,
      positionY,
      isBottom,
      isCenterVertical,
      isCenterHorizontal,
      childrenDefaultWidth,
    ]);

    return (
      <Container ref={ref} {...{ name: name }}>                                                   
        {children}
      </Container>
    );
  }
);
